import { render, staticRenderFns } from "./CertificateContent.vue?vue&type=template&id=2aaaa8e9&"
import script from "./CertificateContent.vue?vue&type=script&lang=js&"
export * from "./CertificateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports